// extracted by mini-css-extract-plugin
export default {"paragraphDescription":"Consents_paragraphDescription__vhnKI","azurePortalLinkContainer":"Consents_azurePortalLinkContainer__J5XqX"};